import { toast } from '@approvalmax/ui/src/components';
import { hooks } from '@approvalmax/utils';
import { createPath } from 'history';
import { constants, selectors } from 'modules/common';
import { useSelector } from 'modules/react-redux';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { routingService } from 'services/routing';
import { getApiUrl } from 'shared/data';
import { useConnectSlackUser } from 'shared/data/slack/v1';
import { getDefaultPath, getPath, Path } from 'urlBuilder';

import { messages } from '../messages';

export const useSlackAuthConnectUserPage = () => {
    const location = useLocation();

    const [user] = hooks.useQueryParam('user');
    const [state] = hooks.useQueryParam('state');
    const [error] = hooks.useQueryParam('error');
    const [errorDescription] = hooks.useQueryParam('error_description');

    const isAuthenticated = useSelector(selectors.session.authenticated);

    const { data } = useConnectSlackUser(
        { query: { user, state } },
        {
            enabled: isAuthenticated,
            onError: () => {
                toast.error(messages.errorPageLoad);

                routingService.push(getDefaultPath());
            },
        }
    );

    useEffect(() => {
        if (!error) {
            return;
        }

        if (error === 'access_denied') {
            window.location.href = constants.commonConstants.SLACK_APP_URL;
        } else {
            toast.error(errorDescription);

            routingService.push(getDefaultPath());
        }
    }, [error, errorDescription]);

    useEffect(() => {
        if (!isAuthenticated) {
            toast.error(messages.errorAccessDenied);

            routingService.push(getPath(Path.login, { redirectPath: createPath(location) }));
        }

        if (isAuthenticated && !user) {
            toast.error(messages.errorPageLoad);

            routingService.push(getDefaultPath());
        }
    }, [isAuthenticated, location, user]);

    useEffect(() => {
        if (data && !data.isStateExists) {
            const slackApi = getApiUrl({ apiSource: 'slack' });

            routingService.reloadToUrl(`${slackApi}auth/connect-to-am`);
        }
    }, [data]);
};
